import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClipboardListIcon, CheckIcon } from 'lucide-react';
export function BonusSection() {
  const checklist = ['Registro diario de siestas y sueño nocturno', 'Seguimiento de despertares nocturnos', 'Checklist de rutina nocturna'];
  return <section className="py-12 md:py-20 px-4 md:px-6 relative overflow-hidden" data-id="element-21">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gold/5 -skew-x-12 transform origin-top-right -z-10" data-id="element-22"></div>

      <div className="max-w-6xl mx-auto" data-id="element-23">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-20" data-id="element-24">
          <div className="flex-1 order-2 lg:order-1 w-full max-w-xs md:max-w-md lg:max-w-none relative" data-id="element-25">
            <FadeIn direction="right" data-id="element-26">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-square" data-id="element-27">
                <div className="absolute inset-0 bg-gold/10 mix-blend-overlay z-10" data-id="element-28"></div>
                <img src="https://cdn.magicpatterns.com/uploads/oMKSkEaMYzGL9tYvb1W3fb/heylloyd-image-1772909489716.png" alt="Mamá sonriendo a su hija dormida en la cama" className="object-cover w-full h-full" loading="lazy" decoding="async" data-id="element-29" />
              </div>
              <div className="absolute -inset-4 bg-gold/20 blur-3xl -z-10 rounded-full opacity-40" data-id="element-30"></div>
            </FadeIn>
          </div>

          <div className="flex-1 order-1 lg:order-2" data-id="element-31">
            <FadeIn data-id="element-32">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-gold/10 text-gold font-medium text-xs md:text-sm mb-4 md:mb-6 uppercase tracking-wider" data-id="element-33">
                <ClipboardListIcon className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-34" />
                Regalo Especial
              </div>

              <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif mb-4 md:mb-6 text-white" data-id="element-35">
                <span className="text-gold" data-id="element-36">BONUS:</span> <br data-id="element-37" />
                Planificador de Sueño del Bebé
              </h2>

              <p className="text-base md:text-xl font-serif italic text-gold mb-4 md:mb-6" data-id="element-38">
                Porque no basta con "leer" — necesitas ver lo que está pasando
                en tu día a día.
              </p>

              <p className="text-sm md:text-lg text-white/70 mb-5 md:mb-8" data-id="element-39">
                Con este planificador podrás identificar patrones y mejorar el
                sueño paso a paso. Incluye:
              </p>
            </FadeIn>

            <ul className="space-y-2.5 md:space-y-4 mb-5 md:mb-8" data-id="element-40">
              {checklist.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-41">
                  <li className="flex items-center gap-2.5 md:gap-3 bg-navy-card px-4 py-3 md:px-5 md:py-4 rounded-lg md:rounded-xl shadow-sm border border-navy-light" data-id="element-42">
                    <div className="flex-shrink-0 bg-gold/10 rounded-full p-0.5 md:p-1" data-id="element-43">
                      <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-gold" data-id="element-44" />
                    </div>
                    <span className="text-sm md:text-base text-white font-medium" data-id="element-45">
                      {item}
                    </span>
                  </li>
                </FadeIn>)}
            </ul>

            <FadeIn delay={0.4} data-id="element-46">
              <p className="text-sm md:text-lg font-medium text-white bg-navy-light p-4 md:p-5 rounded-lg md:rounded-xl border-l-4 border-gold" data-id="element-47">
                Esto te ayudará a dejar de adivinar y empezar a ajustar con
                claridad.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}